import { useTranslation } from 'react-i18next';

const GetLastBackup = ({ info }: { info: any }) => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();
  
  if (!info) return <div>{t('admin.there_is_no_backup_yet')}</div>;
  return (
    <div style={{ maxWidth: '500px', margin: '40px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
      {info && (
        <div style={{ fontSize: '0.9rem', marginTop: '10px' }}>
          <strong>{t('admin.last_backup')}:</strong><br />
          {t('admin.file_name')}: <code>{info.name}</code><br />
          {t('admin.generated_at')}: <code>{info.timestamp}</code><br />
          {t('admin.uploaded')}: <code>{info.uploadedAt ? `✅ ${t('answer.yes')}` : `❌ ${t('answer.no')}`}</code><br />
          {t('admin.google_drive_file_id')}: <code>{info.googleDriveFileId}</code>
        </div>
      )}
    </div>
  );
};

export default GetLastBackup;

